// In dev, point at our own origin so requests are same-origin and Vite's
// dev-server proxy (see vite.config.ts) forwards them to the real backend.
// SuperTokens requires a non-empty apiDomain, so we can't just use ''.
const devApiDomain =
  typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5173'
const prodApiDomain = import.meta.env.VITE_API_DOMAIN ?? 'http://localhost:8000'

export const appInfo = {
  appName: 'Aurilearn Labs',
  apiDomain: import.meta.env.DEV ? devApiDomain : prodApiDomain,
  apiBasePath: import.meta.env.VITE_AUTH_BASE_PATH ?? '/api/auth',
  sessionScope: import.meta.env.VITE_SESSION_SCOPE ?? 'localhost',
  appUrl: import.meta.env.VITE_APP_URL ?? 'http://localhost:3000'
}
